/**
 * 공지사항 서비스
 */

import apiClient from './api';
import {
  Notice,
  NoticeFilter,
  NoticeListResponse,
} from '../types/notice';

export const noticeService = {
  /**
   * 공지사항 목록 조회
   */
  async getNotices(filter: NoticeFilter = {}): Promise<NoticeListResponse> {
    const params = new URLSearchParams();
    
    if (filter.notice_type) params.append('notice_type', filter.notice_type);
    if (filter.status) params.append('status', filter.status);
    if (filter.is_main_visible !== undefined) params.append('is_main_visible', filter.is_main_visible.toString());
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: NoticeListResponse }>(`/admin/notices?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      notices: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 공지사항 상세 조회
   */
  async getNotice(id: number): Promise<Notice> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { notice: Notice } }>(`/admin/notices/${id}`);
    // return response.data.data.notice;

    throw new Error('Not implemented');
  },

  /**
   * 공지사항 등록
   */
  async createNotice(data: Partial<Notice>): Promise<Notice> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { notice: Notice } }>('/admin/notices', data);
    // return response.data.data.notice;

    throw new Error('Not implemented');
  },

  /**
   * 공지사항 수정
   */
  async updateNotice(id: number, data: Partial<Notice>): Promise<Notice> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { notice: Notice } }>(`/admin/notices/${id}`, data);
    // return response.data.data.notice;

    throw new Error('Not implemented');
  },

  /**
   * 공지사항 삭제
   */
  async deleteNotice(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/notices/${id}`);

    throw new Error('Not implemented');
  },
};

